// app/error.js
'use client';

export default function GlobalError({ reset }) {
  return (
    <html>
      <body className="min-h-screen">
        <main className="mx-auto max-w-3xl p-6">
          <p className="cig-section-label">Service state</p>
          <h1 className="mt-4 text-2xl font-semibold">Something went wrong.</h1>
          <p className="mt-4 text-sm">Please try again.</p>
          <button className="cig-btn-primary mt-6" onClick={reset}>Try again</button>
        </main>
      </body>
    </html>
  );
}
